import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterLink, Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AppService, AppSettingService, AppUtilityService } from '../app.service';
import { UserInfoService, IUserProfile } from '../user/user-info.service';
import { WebAPIService } from '../user/user-api.service';
import { AccountAPIService } from '../user/account-api.service';
import { AnonymousUserService } from '../user/anonymousUser/anonymous-user.service';
import { ZoneAPIService } from '../zone/zone-api.service';
import * as MapAPI from '../map/map-api.service';
import  * as WidgetAPI from '../widget/widget-api.service';
import { SwitchAccountComponent } from '../user/switchAccount/switch-account.component';
import { NotificationComponent } from '../notification/notification.component';
import { MyProfileService } from '../user/myProfile/my-profile.service';
import { NavigationService } from './navigation.service';

@Component({
	selector: 'app-navigation-header',
	templateUrl: './navigation-header.component.html',
	styleUrls: ['./navigation.component.scss'],
	imports: [NgbDropdownModule, SwitchAccountComponent, NotificationComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationHeaderComponent implements OnInit {
	constructor(
		private accountAPI: AccountAPIService,
		private anonymousSrv: AnonymousUserService,
		public appSetting: AppSettingService,
		private appSrv: AppService,
		private cdr: ChangeDetectorRef,
		private location: Location,
		private mapAPI: MapAPI.MapAPIService,
		private myProfileSrv: MyProfileService,
		public navigationSrv: NavigationService,
		private router: Router,
		public userInfo: UserInfoService,
		private webAPI: WebAPIService,
		public widgetAPI: WidgetAPI.WidgetAPIService,
		private zoneAPI: ZoneAPIService
	) {}

	user: IUserProfile = null;
	personInfo: any = null;
	loggedIn: boolean = false;
	isAnonymous: boolean = true;
	allowSignup: boolean = false;
	isSystemAdmin: boolean = false;
	zoneName: string = '';
	pathName: string = '';
	profileImage: string = "assets/images/userImage.png";
	profileReady: boolean = false;
	defaultLogoMobileThresh: number = 430;

	goto(url: string): void {
		if (url === 'openSignup') {
			this.anonymousSrv.openSignupLogin("signup", "", false, "", null);
		}
		else if (url === 'openLogin') {
			this.anonymousSrv.openSignupLogin("login", "", false, "", null);
		}
		else if (url === "help") {
			window.open("https://intercom.help/journeys-acc277045d6d", "_blank");
		}
		else if (url === "dashboard") {
			this.widgetAPI.getDefaultDashboard().subscribe({
				next: (response: WidgetAPI.TWidgetName) => {
					switch (response) {
						case "MyActivity":
							this.router.navigateByUrl("/Activity/Self");
							break;
						case "EmployerDashboard":
							this.router.navigateByUrl("/Employer/Dashboard");
							break;
						case "ClientDashboard":
							this.router.navigateByUrl("/ClientDashboard/User");
							break;
						default:
							this.router.navigateByUrl("/User/ProfileDashboard");
							break;
					}
					this.cdr.markForCheck();
				},
				error: (err: any) => {
					console.log(err.error);
					this.router.navigateByUrl("/User/ProfileDashboard");
					this.cdr.markForCheck();
				}
			});
		}
		else if (url === "map") {
			this.mapAPI.getUserDefaultMapType().subscribe({
				next: (response: MapAPI.TMapType) => {
					switch (response) {
						case "JourneyMap":
							// cps ask to reload map when it is clicked on the top navigation
							this.appSrv.redirectReload("/Map");
							break;
						case "LadderMap":
							this.router.navigateByUrl("/LadderMap");
							break;
					}
					this.cdr.markForCheck();
				},
				error: (err: any) => {
					this.appSrv.redirectReload("/Map");
					this.cdr.markForCheck();
				}
			});
		}
		else if (this.userInfo.isAnonymous()) {
			this.anonymousSrv.openSignupLogin("login", url, true, "", null);
		}
		else {
			this.router.navigateByUrl(url);
		}
	};

	loadingWeb: boolean = false;
	gotoWeb(): void {
		if (!this.userInfo.isSystemAdmin) {
			return;
		}
		this.loadingWeb = true;
		this.webAPI.signOn().subscribe({
			next: () => {
				window.location.href = "/Users/PersonEdit.aspx";
				this.loadingWeb = false;
				this.cdr.markForCheck();
			},
			error: (err: any) => {
				this.loadingWeb = false;
				console.log(err);
				this.cdr.markForCheck();
			}
		});
	}


	logout(): void {
		this.userInfo.clearProfile(true);
	}

	getProfilePhoto(): void {
		this.accountAPI.getMyProfile().subscribe({
			next: (response: any) => {
				this.profileImage = response.Photo;
				this.cdr.markForCheck();
			},
			error: (error: any) => {
				console.log(error);
				this.cdr.markForCheck();
			}
		});
	};

	goHomehLink(): void {
		if (this.userInfo.getHomePage() != '') {
			this.appSrv.goTo(this.userInfo.getHomePage());
		}
	}

	storedLocation = this.location.path();

	private loadUserInfo(): void {
		this.personInfo = null;
		this.user = this.userInfo.getProfile();
		this.loggedIn = this.userInfo.isLogin();
		this.isAnonymous = this.userInfo.isAnonymous();
		this.allowSignup = this.userInfo.allowSignup();
		this.zoneName = this.userInfo.zoneName;

		if (!this.isAnonymous) {
			this.isSystemAdmin = this.userInfo.isSystemAdmin;
			this.personInfo = this.user;
			this.getProfilePhoto();
		}
		else {
			this.isSystemAdmin = false;
		}
		this.profileReady = true;
	}

	private loadLogo(): void {
		this.zoneAPI.getZoneByName(this.zoneName).subscribe({
			next: (response: any) => {
				// if this is journey logo and on mobile, user smaller
				if (response.Logo.length > 0) {
					this.navigationSrv.navLogo = response.Logo;
					this.navigationSrv.logo = response.Logo;
				}
				if (window.innerWidth < this.defaultLogoMobileThresh) {
					this.navigationSrv.logo = this.navigationSrv.mobileLogo;
				} 
				this.cdr.markForCheck();
			},
			error: (error: any) => {
				console.log(error);
				this.cdr.markForCheck();
			}
		});
	}

	private logoMonitor: Subscription;
	private accountMonitor: Subscription;
	private photoMonitor: Subscription;
	private monitorProfileChange(): void {
		//watch session change
		this.accountMonitor = this.userInfo.UserInfoTimestamp.subscribe({
			next: () => {
				this.loadUserInfo();
				this.loadLogo();
				this.cdr.markForCheck();
			},
			error: (err: any) => {
				console.log(err);
				this.loadUserInfo();
				this.loadLogo();
				this.cdr.markForCheck();
			}
		});

		this.photoMonitor = this.myProfileSrv.PhotoChanged.subscribe({
			next: () => {
				this.loadUserInfo();
				this.cdr.markForCheck();
			},
			error: (err: any) => {
				console.log(err);
				this.cdr.markForCheck();
			}
		});

		this.logoMonitor = this.navigationSrv.logoChanged.subscribe({
			next: () => {
				this.cdr.markForCheck();
			},
			error: (err: any) => {
				console.log(err);
				this.cdr.markForCheck();
			}
		});
	}

	ngOnDestroy() {
		if (this.accountMonitor) {
			this.accountMonitor.unsubscribe();
		}
		if (this.photoMonitor) {
			this.photoMonitor.unsubscribe();
		}
		if (this.logoMonitor) {
			this.logoMonitor.unsubscribe();
		}
	}

	ngOnInit(): void {
		this.monitorProfileChange();
	}
}


@Component({
	selector: 'app-navigation-footer',
	templateUrl: './navigation-footer.component.html',
	styleUrls: ['./navigation.component.scss'],
	imports: [RouterLink],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationFooterComponent {
	currentYear: number = (new Date()).getFullYear();
}


@Component({
	template: `<div class="row"><div class="offset-1 col-10"><h2 class="mt-5" [innerHTML]="errorMessage"></h2></div></div>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationErrorComponent implements OnInit {
	constructor(
		private userInfo: UserInfoService,
		private router: Router
	) { }

	errorMessage: string = "";

	ngOnInit(): void {
		if (this.router.url.toLowerCase().indexOf("sso") > 0) {
			this.errorMessage = "We love your enthusiasm, but your Journeys Map account is still being created. Please check with your teacher to know when it will be ready!";
		}
		else if (this.router.url.toLowerCase().indexOf("stokenexp") > 0) {
			this.errorMessage = "The given SSO token is expired!";
		}
		else if (this.router.url.toLowerCase().indexOf("permission") > 0) {
			this.errorMessage = "Please check with your system admin to ensure you have rights to access this function!";
		}
		else {
			if (this.userInfo.isAnonymous()) {
				this.router.navigateByUrl("/User/Login");
			}
			else {
				this.errorMessage = "The requested content is not found. Please ensure you have rights to access this page.";
			}
		}
	}
}


@Component({
	template: ``,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationHomeComponent implements OnInit {
	constructor(
		public userInfo: UserInfoService,
		private appSrv: AppService
	) { }

	ngOnInit(): void {
		if (this.userInfo.isAnonymous()) {
			window.location.href = AppSettingService.baseUrl + "/User/Login";
		}
		else {
			if (this.userInfo.getHomePage() != '') {
				this.appSrv.goTo(this.userInfo.getHomePage());
			}
		}
	}
}


@Component({
	template: `<div class="d-flex justify-content-center align-items-center vh-100"><span class="jmWidgetLoadingIcon40"></span></div>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationSplashComponent {
	constructor(private activeRoute: ActivatedRoute) { }
	private routeTo: string = "";

	ngOnInit(): void {
		this.activeRoute
			.queryParams
			.subscribe(
				params => {
					this.routeTo = (params["routeTo"] || "").trim();
					if (this.routeTo !== "") {
						this.routeTo = this.routeTo + ((this.routeTo.indexOf("?") > 0) ? "&" : "?") + "tm=" + AppUtilityService.newId();
						window.location.href = this.routeTo;
					}
				}
			);
	}
}
